import { http } from '@/libs/util';
import util from '@/libs/util'
const { 
    flow_node_user_unusual_order_list,
    contract_related_placing_records,
    outsource_contract_related_placing_records
 } = util.api || {}

 export function getUnusualOrderListApi(params) {
     return http.get(flow_node_user_unusual_order_list, params)
 }


 export function getContractRelatedPlacingRecordsApi(params) {
    return http.get(contract_related_placing_records, params)
}

export function getOutsourceContractRelatedPlacingRecordsApi(params) {
    return http.get(outsource_contract_related_placing_records, params)
}